import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-map-sidebar-items-skeleton',
    templateUrl: './map-sidebar-items-skeleton.component.html',
    styleUrls: ['./map-sidebar-items-skeleton.component.scss'],
    standalone: false,
})
export class MapSidebarItemsSkeletonComponent {
    @Input()
    public displayAsList?: boolean;
}
